import { isInCohort } from 'shared/utils/isInCohort';
import { useFeatureFlag } from 'shared/hooks/useFeatureFlag';
import { FeatureFlags } from 'featureFlags/constants';
import { STORAGE } from 'shared/enums/SitePreferences';
import { useWindowSize } from 'shared/hooks/useWindowSize';

export const useIsNewMobilePdpAccessible = () => {
  const { isMobile } = useWindowSize();
  const isNewMobileWebPdpEnabled = useFeatureFlag(FeatureFlags.TEMP_WEB_ENABLE_NEW_MOBILE_WEB_PDP);
  const webEnableCohortAssignment = useFeatureFlag(FeatureFlags.WEB_ENABLE_COHORT_ASSIGNMENT);
  const isInCohortAssignment =
    webEnableCohortAssignment && isInCohort({ storedCohort: STORAGE.COHORT_ASSIGNMENT });
  const isNewMobilePdpAccessible =
    isMobile && isNewMobileWebPdpEnabled && (!webEnableCohortAssignment || isInCohortAssignment);

  return isNewMobilePdpAccessible;
};
